import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RotatingLines } from 'react-loader-spinner'

type Props = {
  className: string

  loadingClassName?: string

  src: string | undefined

  alt: string
}

const Image: React.FC<Props> = ({ className, loadingClassName, src, alt }: Props) => {
  const { t } = useTranslation()
  const [isLoaded, setIsLoaded] = useState(false)

  const onLoad = () => {
    setIsLoaded(true)
  }

  if (src === undefined) {
    return (
      <div
        className={`${className} ${
          loadingClassName ?? ''
        } text text--size13 text--center text--weight400 text--falseBlack`}
      >
        {t('cruise.noImage')}
      </div>
    )
  }

  return (
    <React.Fragment>
      <img
        style={!isLoaded ? { display: 'none' } : undefined}
        onLoad={onLoad}
        src={src}
        alt={alt}
        className={className}
      />
      {!isLoaded && (
        <div className={`${className} ${loadingClassName ?? ''} image--loading`}>
          <RotatingLines
            strokeColor='grey'
            strokeWidth='5'
            animationDuration='0.75'
            width='40'
            visible={!isLoaded}
          />
        </div>
      )}
    </React.Fragment>
  )
}

export default Image
